import { useQuery } from '@apollo/client/react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { MemberClientGuardDocument } from '../graphql/types';
import GenericError from './reusable/GenericError';
import { LoadingPage } from './reusable/LoadingPage';

const MemberClientGuard: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { memberId } = useParams();
  const navigate = useNavigate();

  const { data, loading, error } = useQuery(MemberClientGuardDocument, {
    variables: { memberId: memberId! },
    skip: !memberId,
  });

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return <GenericError testId="MemberClientGuard-Error" error={error} />;
  }

  if (data?.user?.viewerCanAccess) {
    return children;
  }

  return (
    <Dialog
      open
      aria-labelledby="access-denied-title"
      aria-describedby="access-denied-description"
    >
      <DialogTitle id="access-denied-title">Resource unavailable</DialogTitle>
      <DialogContent>
        <DialogContentText id="access-denied-description">
          This resource cannot be accessed. If you believe this is an error,
          please contact technical support for assistance.
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ marginRight: 18, marginBottom: 12 }}>
        <Button
          style={{ padding: 12, borderRadius: 4, alignSelf: 'flex-end' }}
          variant="contained"
          color="primary"
          onClick={() => navigate('/app/members')}
        >
          Go to Members
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MemberClientGuard;
